import { render, staticRenderFns } from "./PsiSlideSelector.vue?vue&type=template&id=52487cff&scoped=true&"
import script from "./PsiSlideSelector.vue?vue&type=script&lang=js&"
export * from "./PsiSlideSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52487cff",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VDivider,VIcon,VRow,VScaleTransition,VSheet,VSlideGroup,VSlideItem})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52487cff')) {
      api.createRecord('52487cff', component.options)
    } else {
      api.reload('52487cff', component.options)
    }
    module.hot.accept("./PsiSlideSelector.vue?vue&type=template&id=52487cff&scoped=true&", function () {
      api.rerender('52487cff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/src/components/lists/PsiSlideSelector.vue"
export default component.exports